import loadjs from "loadjs"
import { useEffect } from "react"

import Image from "components/ui/image"
import { IS_INT, IS_US, IS_CA } from "helpers/application"

const GiftFinder = () => {
  useEffect(() => {
    const loadSplash = () => {
      window.DIGIOH_API.LIGHTBOX.loadLightbox(
        IS_US() || IS_INT()
          ? "811ca62f-30d6-4deb-b349-5761f726df40" // US & INT 299377
          : IS_CA()
            ? "0a62f81b-8f23-412e-88a4-f7294b2b44aa" // CA 300106
            : "aaf77a34-6e16-42f3-8079-8cfae0bdf61e" // UK & AU 300059
      )
    }

    if (window.DIGIOH_API && window.DIGIOH_API.LIGHTBOX) {
      loadSplash()
    } else {
      loadjs(
        [
          `https://www.lightboxcdn.com/vendor/7c3a4ec6-f10d-4926-b14d-64ee5d0a9611/lightbox_speed.js?mb=${new Date().getTime()}`,
        ],
        { async: true, returnPromise: true }
      )
        .then(() => loadSplash())
        .catch((err) => console.log(`Error loading splash page: ${err}`))
    }
  }, [])

  return (
    <div
      className="[&>*:nth-child(n+2)]:hidden"
      id="gift-finder-splash"
      style={{ minHeight: "560px" }}
    >
      <div className="my-48 text-center" style={{ minHeight: "350px" }}>
        <Image
          alt="Loading"
          height="175"
          lazyload={false}
          src={require("images/layout/loadinglarge.gif")}
          width="175"
        />
      </div>
    </div>
  )
}

export default GiftFinder
